import { State } from '../../../types/state';

export const setMiqAddressPopup = (state:State) => {
    return state.system.setMiqAddress;
}